@if (mode === 'CONTACT-US') {
  <div class="mb-2">Real-time support for our online classes is available during the hours below.</div>
  <div class="fw-semibold mb-1">Support hours in the {{ timeZoneLabel }} timezone are:</div>
  <div class="d-flex flex-column support-hours-list">
    @for (entry of supportHoursSummary; track entry.Day) {
      <div class="d-flex align-items-center gap-1 justify-content-between">
        <span class="text-start">{{ entry.Day }}</span>
        @if (entry.Hours === 'Closed') {
          Closed
        } @else {
          <span class="ms-auto support-hours-label text-end">{{ entry.StartLabel }}</span>
          <span class="support-hours-dash text-end">&ndash;</span>
          <span class="support-hours-label text-end">{{ entry.EndLabel }}</span>
        }
      </div>
    }
  </div>
} @else if (outsideSupportHours) {
  <span class="badge cwk-red-bg support-hours-badge" [ngbPopover]="supportHoursPopover" triggers="mouseenter:mouseleave">Outside Support Hours</span>
}

<ng-template #supportHoursPopover>
  <div class="mb-2">
    @if (isCustomer) {
      Your class is scheduled outside our regular operating hours, so real-time support from our coordinator team will not be available. If you'd like, feel free to contact us to reschedule the class.
    } @else {
      Real-time support from our coordinator team is not available.
    }
  </div>
  <div class="fw-semibold mb-0">Support Hours:</div>
  <div class="mb-1"><small>All times are displayed in the {{ timeZoneLabel }} timezone.</small></div>
  <ul class="list-unstyled mb-0">
    @for (entry of supportHoursSummary; track entry.Day) {
      <li class="d-flex justify-content-between gap-3">
        <span class="text-start">{{ entry.Day }}</span>
        <span class="text-end ms-auto">{{ entry.Hours }}</span>
      </li>
    }
  </ul>
</ng-template>
